'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _Functions = require('../core/Functions');

var _Style = require('../core/Style');

var _Overflows = require('../utils/Overflows');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClassName = function getClassName(_ref, _ref2) {
  var className = _ref.className,
      useFlex = _ref.useFlex;
  var tooltipEnabled = _ref2.tooltipEnabled;

  return (0, _reactUtils.classNames)('private-truncated-string', className, {
    'private-truncated-string--is-flex': useFlex,
    'private-truncated-string--has-tooltip': tooltipEnabled
  });
};

var getInnerClassName = function getInnerClassName(_ref3) {
  var innerClassName = _ref3.innerClassName;

  return (0, _reactUtils.classNames)('private-truncated-string__inner', innerClassName);
};

exports.default = _react2.default.createClass({
  displayName: 'UITruncateString',

  propTypes: {
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    fixedChildren: _react.PropTypes.node,
    innerClassName: _react.PropTypes.string,
    matchContentWidth: _react.PropTypes.bool.isRequired,
    maxWidth: _react.PropTypes.number,
    onMouseEnter: _react.PropTypes.func,
    placement: _UITooltip2.default.propTypes.placement,
    reverse: _react.PropTypes.bool.isRequired,
    tabIndex: _react.PropTypes.number,
    tooltip: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.node, _react.PropTypes.string]).isRequired,
    useFlex: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      placement: _UITooltip2.default.defaultProps.placement,
      reverse: false,
      tooltip: true,
      matchContentWidth: false,
      useFlex: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      contentWidth: undefined,
      isTruncated: false
    };
  },
  componentDidMount: function componentDidMount() {
    // Why the timeout? It prevents us from breaking CSS transitions that start at the same time
    // that this component is mounted. Strange but true! See HubSpot/UIComponents#1799
    setTimeout(this.updateTruncatedState, 0);
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.contentWidth === this.state.contentWidth && prevState.isTruncated === this.state.isTruncated) {
      this.updateTruncatedState();
    }
  },
  handleMouseEnter: function handleMouseEnter(evt) {
    // In case the container has changed in size outside of the React
    // lifecycle, e.g. due to a window resize.
    this.updateTruncatedState();
    var onMouseEnter = this.props.onMouseEnter;

    (0, _Functions.callIfPossible)(onMouseEnter, evt);
  },
  updateTruncatedState: function updateTruncatedState() {
    // If the last render was caused by updateTruncatedState(), we have nothing to do.
    var wrapperEl = this._wrapperEl;
    var contentEl = this._contentEl;
    if (!wrapperEl || !contentEl) {
      return;
    }
    var _props = this.props,
        matchContentWidth = _props.matchContentWidth,
        reverse = _props.reverse;

    var contentWidth = void 0;
    if (matchContentWidth) {
      // We need to temporarily make the content `display: inline-block` for the width calculation.
      contentEl.style.display = 'inline-block';
      contentWidth = contentEl.clientWidth + 1;
      contentEl.style.display = '';
    }

    var isTruncated = void 0;
    if (reverse) {
      var tailEl = this._tailEl;
      if (!tailEl) {
        return;
      }
      isTruncated = (0, _Overflows.overflowsX)(tailEl, wrapperEl);
    } else {
      isTruncated = (0, _Overflows.overflowsX)(wrapperEl);
    }
    if (contentWidth !== this.state.contentWidth || isTruncated !== this.state.isTruncated) {
      this.setState({ contentWidth: contentWidth, isTruncated: isTruncated });
    }
  },
  wrapperRefCallback: function wrapperRefCallback(ref) {
    this._wrapperEl = ref;
  },
  contentRefCallback: function contentRefCallback(ref) {
    this._contentEl = ref;
  },
  tailRefCallback: function tailRefCallback(ref) {
    this._tailEl = ref;
  },
  renderReverseContent: function renderReverseContent(_ref4) {
    var children = _ref4.children;
    var isTruncated = this.state.isTruncated;

    var tailClassName = (0, _reactUtils.classNames)('private-truncated-string__reverse__tail', {
      'is-truncated': isTruncated
    });

    // So much markup!! :'(
    return _react2.default.createElement(
      'span',
      { className: 'private-truncated-string__reverse' },
      isTruncated ? _react2.default.createElement(
        'span',
        { className: 'private-truncated-string__reverse__ellipse' },
        '\u2026'
      ) : null,
      _react2.default.createElement(
        'span',
        { className: tailClassName },
        _react2.default.createElement(
          'span',
          {
            className: 'private-truncated-string__reverse__content',
            ref: this.tailRefCallback
          },
          children
        )
      )
    );
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        className = _props2.className,
        fixedChildren = _props2.fixedChildren,
        innerClassName = _props2.innerClassName,
        __matchContentWidth = _props2.matchContentWidth,
        maxWidth = _props2.maxWidth,
        placement = _props2.placement,
        reverse = _props2.reverse,
        tabIndex = _props2.tabIndex,
        tooltip = _props2.tooltip,
        useFlex = _props2.useFlex,
        rest = _objectWithoutProperties(_props2, ['children', 'className', 'fixedChildren', 'innerClassName', 'matchContentWidth', 'maxWidth', 'placement', 'reverse', 'tabIndex', 'tooltip', 'useFlex']);

    var _state = this.state,
        contentWidth = _state.contentWidth,
        isTruncated = _state.isTruncated;

    // We only want to show a tooltip if the content is actually truncated.

    var tooltipEnabled = tooltip !== false && isTruncated;

    // When maxWidth is set, we need to set maxWidth on both the outer container and the inner
    // wrapper. We also need to set width to "unset" (if we aren't using matchContentWidth) in
    // order to prevent the table column from collapsing to 0 due to the `width: 100%` rule.
    var computedMaxWidth = maxWidth && contentWidth ? Math.min(maxWidth, contentWidth) : maxWidth || contentWidth;
    var style = computedMaxWidth ? {
      maxWidth: (0, _Style.remCalc)(computedMaxWidth),
      width: maxWidth ? 'unset' : undefined
    } : undefined;

    var renderedBrokenString = _react2.default.createElement(
      'span',
      _extends({}, rest, {
        className: getClassName({ className: className, useFlex: useFlex }, { tooltipEnabled: tooltipEnabled }),
        onMouseEnter: this.handleMouseEnter,
        style: style,
        tabIndex: tooltipEnabled ? tabIndex || 0 : tabIndex
      }),
      _react2.default.createElement(
        'span',
        {
          className: getInnerClassName({ innerClassName: innerClassName }),
          ref: this.wrapperRefCallback,
          style: style
        },
        _react2.default.createElement(
          'span',
          { ref: this.contentRefCallback },
          reverse ? this.renderReverseContent({ children: children }) : children
        )
      ),
      fixedChildren
    );

    if (tooltipEnabled) {
      return _react2.default.createElement(
        _UITooltip2.default,
        {
          placement: placement,
          title: typeof tooltip === 'boolean' ? children : tooltip
        },
        renderedBrokenString
      );
    }
    return renderedBrokenString;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/text/UITruncateString.js
// module id = 47
// module chunks = 0